import { useEffect } from 'react';
import * as Sentry from '@sentry/react-native';

import { useUser } from '@/states/auth/user';

/**
 * Hook to automatically set Sentry user context when user logs in/out
 */
export function useSentryUserContext() {
  const user = useUser();

  useEffect(() => {
    if (user) {
      // Set user context in Sentry
      Sentry.setUser({
        id: user.id,
        email: user.email,
        username:
          user.github?.username || user.name || user.email?.split('@')[0],
      });

      // Add additional context
      Sentry.setContext('subscription', {
        isSupporter: user.isSupporter,
        planStatus: user.plan?.status,
        subscriptionType: user.plan?.subscriptionType,
      });

      // Add user tags for easier filtering
      Sentry.setTag('user.supporter', user.isSupporter);
      Sentry.setTag('user.has_github', !!user.github);

      if (user.plan?.status) {
        Sentry.setTag('subscription.status', user.plan.status);
      }
    } else {
      // Clear user context when logged out
      Sentry.setUser(null);
      Sentry.setContext('subscription', null);
      Sentry.setTag('user.supporter', false);
      Sentry.setTag('user.has_github', false);
      Sentry.setTag('subscription.status', 'none');
    }
  }, [user]);
}
